import { PostAPI } from 'Components/Helper/Helpers';

export const AddAPIAgent = async (request) => {
    return PostAPI(request, 'EzyPayAEPS/AddAgent');
};


export const AgentOnboard = async (request) => {
    return PostAPI(request, 'EzyPayAEPS/AgentOnboard');
};


export const Authentication = async (request) => {
    return PostAPI(request, 'EzyPayAEPS/TwoFactorAuthentication');
};

export const BalanceEnquiry = async (request) => {
    return PostAPI(request, 'EzyPayAEPS/BalanceCheck');

};
export const cashWithdrawal = async (request) => {
    return PostAPI(request, 'EzyPayAEPS/CashWithdrawal');
};

export const miniStatement = async (request) => {
    return PostAPI(request, 'EzyPayAEPS/MiniStatement');
};

export const CheckUserOnboard = async (request) => {
    return PostAPI(request, 'EzyPayAEPS/CheckUserOnboard');
};
export const MerchantActivation = async (request) => {
    return PostAPI(request, 'EzyPayAEPS/UploadDocumentKYC');
};

export const APIAgentKYCStatus = async (request) => {
    return PostAPI(request, 'EzyPayAEPS/APIAgentKYCStatus');
};
export const AgentOnboardingStatus = async (request) => {
    return PostAPI(request, 'EzyPayAEPS/AirtelOnboardingStatus');
};

